(window as any).global ??= window;

if (!Array.prototype.flatMap) {
    Array.prototype.flatMap = function (f, ctx) {
        // @ts-expect-error error TS2683: 'this' implicitly has type 'any' because it does not have a type annotation.
        return this.reduce((r, x, i, a) => r.concat(f.call(ctx, x, i, a)), []);
    } as typeof Array.prototype.flatMap<any, any>;
}
